import React from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import Tab from "react-bootstrap/Tab";
import { Container, Row, Col, Table } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import LeftAdministration from "./LeftAdministration";

function Main() {
  return (
    <>
      <Header />
      <Breadcrumb title="Home" subtitle="Administration" />
      <section className="project-detail">
        <div className="container">
          <div className="section-title center-align mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
            <h5><i className="fal fa-graduation-cap" /> Administration</h5>
            <h2>Finance Committee</h2>
          </div>

          <Row>
            <Col md={4} className="c-left ">
              <LeftAdministration activeIndex={3} />
            </Col>

            <Col md={8} className="c-left ">
              <table className="table table-striped">
                <tbody className="c-lineheight2dot5 align-middle ms-3 c-table">
                  <tr>
                    <td>
                    <Link
                          to="https://iittp.ac.in/bog-chairman"
                          target="_blank;"
                        >
                          <b>Shri Sajjan Jindal</b>
                        </Link><br />
                      <b>Chairman, BoG</b>  <br />
                      Ex-Officio
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Sajjan%20Jindal_BoG_Chairman.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Chairman</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    <Link
                          to="https://iittp.ac.in/director"
                          target="_blank;">
                        <b>Prof. K. N. Satyanarayana</b>
                        </Link>                        <br />
                      <b>Director</b>  
                      <br />
                      IIT Tirupati
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/director.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Additional Secretary (TE)</b>    <br />
                      MHRD
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/noimages.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Joint Secretary &amp; FA</b>   
                      <br />
                      MHRD
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/noimages.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Prof. Venkata Ramana Badarla</b><br />
                      <b>Dean, Administration &amp; Finance</b>   
                      <br />
                      IIT Tirupati
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/ramana.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Prof. A. Murali Krishna</b><br />
                      <b>Dean, Planning &amp; Infrastructure</b>   
                      <br />
                      IIT Tirupati
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/AMK-NEW.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Prof. David Koilpillai, Professor</b>   
                      <br />
                      IIT Madras
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://www.ee.iitm.ac.in/~koilpillai/assets/img/david.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Brig. Dr. K. P. Krishna Kumar (Retd.)</b><br />
                      <b>Registrar</b>   
                      <br />
                      IIT Tirupati
                    </td>
                    <td>
                      <div className="team-thumb-sm text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/registrar.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member Secretary</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}

export default Main;
